// extracted by mini-css-extract-plugin
export default {"complement_look":"ComplementLook_complement_look__GB7QM"};